//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import { mdiCurrencyUsd } from '@mdi/js'
import { ref } from '@vue/composition-api'
import useVuetify from '@core/utils/vuetify'

export default {
  setup() {
    const progress = ref(75)
    const { rootThemeClasses } = useVuetify()

    return {
      progress,
      rootThemeClasses,
      icons: {
        mdiCurrencyUsd,
      },
    }
  },
}
